
import { fake, fakeUS } from '@/fake.js'

export default {
    getTracker(id) {
        return new Promise((resolve, reject) => {
            setTimeout(function () {
                resolve(fakeUS);
            }, 5);
        });
    }
}